// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { MainWindowManager } from './UtilsClasses/MainWindowManager';
import { PanelLocKeys } from './UtilsClasses/FactoryConstants';
import { AUTO_HIDE_AVALIABLE_PANELS_COUNT, AUTO_HIDE_BLOCK_WIDTH, BOTTOM_WINDOWS_MARGIN, PADDING_OFFSET_LEFT, TOP_BOTTOM_PADDING_OFFSET, TOP_WINDOWS_MARGIN } from './UtilsClasses/SizeConstants';
import { CustomEvent } from '@shared/utils/CustomEvents';
import $ from 'jquery';
export class DockSystem {
    constructor() {
        this.DivForFloatWindow = null;
        this.HiddenPanelsContainer = null;
        this.dockChangedEvent = new CustomEvent();
        this.dockRebuildEvent = new CustomEvent();
        this.dockManager = null;
        this.documentNode = null;
        this.divDockManager = null;
        this.emptyState = null;
        this.parentNodeID = null;
        this.parentNodeDOM = null;
        this.currentPageDockedWindowsForRestore = {};
        this.currentPageDockedWindowsNeedFocusAfterRestore = [];
        this.AutoHidePanelsPool = {};
        this.AutoHide = false;
        this.AutoHideContainer = null;
        this.dockChangedEvent.Subscribe(this.dockChangedCallback, this);
        this.resizeObserver = new ResizeObserver(() => {
            DockSystemInstance.resizeDockSystem();
        });
    }
    static InitSystem(parentNode) {
        const parentNodeDOM = document.getElementById(parentNode);
        const innerContainer = document.createElement('div');
        innerContainer.style.display = 'inline-block';
        // TODO fix exception when /myportfolio is loading
        if (!parentNodeDOM)
            return;
        const divDockManager = parentNodeDOM.appendChild(innerContainer);
        const dockManager = new window.dockspawn.DockManager(divDockManager);
        dockManager.initialize();
        const DS = DockSystemInstance;
        DS.dockManager = dockManager;
        DS.divDockManager = divDockManager;
        DS.documentNode = dockManager.context.model.documentManagerNode;
        // DS.emptyState = DockSystemInstance.getState();
        DS.parentNodeID = parentNode;
        DS.parentNodeDOM = parentNodeDOM;
        DS.resizeObserver.observe(parentNodeDOM);
        DS.resizeDockSystem();
        DockSystem.divForFloatWindow = DS.DivForFloatWindow = document.getElementById('AttachedPanelsContainer');
        DockSystem.hiddenPanelsContainer = DS.HiddenPanelsContainer = document.getElementById('HiddenPanelsContainer');
    }
    resizeDockSystem() {
        if (!isNullOrUndefined(this.divDockManager) && !isNullOrUndefined(this.dockManager)) {
            const sideBarDiv = document.getElementsByClassName('side-bar-backing')[0];
            const sideBarWidth = !isNullOrUndefined(sideBarDiv) ? sideBarDiv.clientWidth : 0;
            const w = window.innerWidth -
                (this.divDockManager.clientLeft + 2 * PADDING_OFFSET_LEFT + sideBarWidth) -
                (this.AutoHide ? AUTO_HIDE_BLOCK_WIDTH : 0);
            const h = window.innerHeight -
                (this.divDockManager.clientTop +
                    TOP_WINDOWS_MARGIN +
                    BOTTOM_WINDOWS_MARGIN +
                    2 * TOP_BOTTOM_PADDING_OFFSET);
            this.dockManager.resize(w, h);
            if (!isNullOrUndefined(this.AutoHideContainer)) {
                this.AutoHideContainer.style.height = h + 'px';
            }
        }
    }
    addPanelOnDock(panel, dockPlace, lockedWorkspace) {
        const newDOM_Element = panel.find('*');
        const newPanel = new window.dockspawn.PanelContainer(newDOM_Element, this.dockManager, panel.get('header'));
        panel.setTitle = newPanel.setTitle.bind(newPanel);
        panel.updateLinkVisible = newPanel.updateLinkVisible.bind(newPanel);
        panel.containerSetFocus = newPanel.setFocus.bind(newPanel);
        panel.PanelContainer = newPanel;
        let documentManagerNode = this.dockManager.context.model.documentManagerNode;
        let newDockedPanelNode = null;
        const referenceNode = this.findReferenceNodeForDocking(this.dockManager.context.model.rootNode, null, this.getDockPlaceInfo(dockPlace));
        newPanel.dockPlace = dockPlace;
        if (referenceNode) {
            const newNode = this.dockManager.CreateDockNode(newPanel);
            documentManagerNode = referenceNode;
        }
        else {
            if (dockPlace === DockPlaceConst.Middle && // #88009
                documentManagerNode.container &&
                !documentManagerNode.container.isDocumentManagerContainer) // if need correction
             {
                this.documentManagerContainerWasFound = false;
                this.correctDocumentManagerContainer(this.dockManager.context.model.rootNode);
                documentManagerNode = this.dockManager.context.model.documentManagerNode; // update after correction
            }
        }
        const referenceNodeHasSameDockPlace = referenceNode && referenceNode.container.dockPlace == dockPlace;
        if (referenceNodeHasSameDockPlace) {
            dockPlace = DockPlaceConst.Middle;
        }
        switch (dockPlace) {
            case DockPlaceConst.Middle:
                newDockedPanelNode = this.dockManager.dockFill(documentManagerNode, newPanel);
                break;
            case DockPlaceConst.Up:
                newDockedPanelNode = this.dockManager.dockUp(documentManagerNode, newPanel, 0.3);
                break;
            case DockPlaceConst.Down:
                newDockedPanelNode = this.dockManager.dockDown(documentManagerNode, newPanel, 0.3);
                break;
            case DockPlaceConst.Left:
                newDockedPanelNode = this.dockManager.dockLeft(documentManagerNode, newPanel, 0.3);
                break;
            case DockPlaceConst.Right:
                newDockedPanelNode = this.dockManager.dockRight(documentManagerNode, newPanel, 0.3);
                break;
        }
        this.tryPermanentlyHideCloseButton(newPanel, panel);
    }
    addAutoHideContainer() {
        const newNode = document.createElement('div');
        newNode.classList.add('oe_vertical_autohide_container');
        this.AutoHideContainer = newNode;
        this.parentNodeDOM.appendChild(newNode);
    }
    RegisterPanel(panel) {
        this.AutoHidePanelsPool[panel._guid] = panel;
    }
    UnRegisterPanel(panel) {
        delete this.AutoHidePanelsPool[panel._guid];
    }
    UpdatePanelsAutoHideSate() {
        const isAv = this.isAutoHideAvaliable();
        for (const panel_g in this.AutoHidePanelsPool) {
            const panel = this.AutoHidePanelsPool[panel_g];
            if (panel === null || panel === void 0 ? void 0 : panel.UpdateAutoHideSate) {
                panel.UpdateAutoHideSate(isAv);
            }
        }
    }
    ForcedHideOthers(iniPanel) {
        const panel_ID = iniPanel._guid;
        for (const panel_g in this.AutoHidePanelsPool) {
            if (panel_g === panel_ID) {
                continue;
            }
            const panel = this.AutoHidePanelsPool[panel_g];
            if (panel === null || panel === void 0 ? void 0 : panel.ForcedAutoHide) {
                panel.ForcedAutoHide();
            }
        }
    }
    isAutoHideAvaliable() {
        if (!this.AutoHideContainer) {
            return true;
        }
        return DockSystemInstance.AutoHideContainer.childElementCount < AUTO_HIDE_AVALIABLE_PANELS_COUNT;
    }
    addToAutoHide(panel) {
        const newNode = document.createElement('div');
        newNode.classList.add('oe_vertical_autohide');
        newNode.innerText = panel.get('header');
        this.AutoHide = true;
        if (!this.AutoHideContainer) {
            this.addAutoHideContainer();
        }
        this.AutoHideContainer.appendChild(newNode);
        panel._myNodeAutoHide = newNode;
        panel.AutoHideHeaderUpdateHandler = function (headerText) {
            this._myNodeAutoHide.innerText = headerText;
        };
        const me = this;
        newNode.addEventListener('mouseenter', function (event) {
            panel.onMouseEnter();
            me.ForcedHideOthers(panel);
        });
        newNode.addEventListener('mouseleave', function (event) {
            panel.onMouseLeave();
        });
        this.resizeDockSystem();
        this.UpdatePanelsAutoHideSate();
    }
    removeFromAutoHide(panel) {
        if (!this.AutoHide && isNullOrUndefined(this.AutoHideContainer)) {
            return;
        }
        const node = panel._myNodeAutoHide;
        panel.AutoHideHeaderUpdateHandler = null;
        if (!isNullOrUndefined(node)) {
            node.parentNode.removeChild(node);
        }
        if (isNullOrUndefined(this.AutoHideContainer)) {
            this.AutoHide = false;
        }
        if (!isNullOrUndefined(this.AutoHideContainer) && this.AutoHideContainer.childElementCount === 0) {
            this.AutoHide = false;
            this.AutoHideContainer.parentNode.removeChild(this.AutoHideContainer);
            this.AutoHideContainer = null;
        }
        this.resizeDockSystem();
        this.UpdatePanelsAutoHideSate();
    }
    tryPermanentlyHideCloseButton(panelContainer, panel) {
        // +++
        const panelType = panel.getType();
        if (panelType) {
            const panelTypeLocKey = PanelLocKeys[panelType];
            if (panelTypeLocKey && Resources.isHidden(panelTypeLocKey + '.allowPanelCloseFromButton')) {
                panel.set('isCloseButtonAlwaysHidden', true);
                panelContainer.hideCloseButton(true);
            }
        }
    }
    addToArrRestore(panel) {
        const newDOM_Element = panel.find('*');
        const id = panel.get('workSpaceId');
        if (id !== null) {
            this.currentPageDockedWindowsForRestore[id] = newDOM_Element;
        }
    }
    // isDock: if true - panel dock, false - panel undock
    dockChangedCallback(panelName, isDock) {
        if (this.lastChangedPanel === panelName && isDock) {
            return;
        }
        this.lastChangedPanel = panelName;
        this.dockRebuildEvent.Raise();
    }
    clearDocking() {
        $(this.parentNodeDOM).empty();
        $(DockSystem.divForFloatWindow).empty();
        DockSystem.InitSystem(this.parentNodeID);
        this.currentPageDockedWindowsForRestore = {};
        this.dockRebuildEvent.clearSubscribers();
        this.AutoHidePanelsPool = {};
        this.AutoHide = false;
        this.AutoHideContainer = null;
    }
    getState() {
        const state = this.dockManager.saveState();
        // console.log(state);
        return state;
    }
    refresh() {
        this.dockManager.rebuildLayout(this.dockManager.context.model.documentManagerNode);
    }
    setState(state) {
        if (state) {
            this.dockManager.loadState(state);
            this.MigationProcess();
        }
    }
    getPanelForDocking(id) {
        const panel = this.currentPageDockedWindowsForRestore[id];
        if (!panel) {
            return null;
        }
        delete this.currentPageDockedWindowsForRestore[id];
        return panel;
    }
    goInProcces(panel, defaultDockPlace) {
        if (!panel)
            return;
        panel.dockPlace = defaultDockPlace;
        panel.append = true;
        panel.render(DockSystem.hiddenPanelsContainer);
        MainWindowManager.MainWindow.registerControl(panel);
    }
    setPlace(id, dockPlace) {
        var _a, _b;
        const panel = this.getPanelForDocking(id);
        const toRestoreContainer = this.dockManager.restoredHashContainers[id];
        const panelRactive = (_b = (_a = panel === null || panel === void 0 ? void 0 : panel._ractive) === null || _a === void 0 ? void 0 : _a.proxy) === null || _b === void 0 ? void 0 : _b.ractive;
        if (isNullOrUndefined(panelRactive) || !toRestoreContainer) {
            return;
        }
        panelRactive.setSize(toRestoreContainer.elementContentHost.clientWidth, toRestoreContainer.elementContentHost.clientHeight);
        panelRactive.setTitle = toRestoreContainer.setTitle.bind(toRestoreContainer);
        panelRactive.containerSetFocus = toRestoreContainer.setFocus.bind(toRestoreContainer);
        panelRactive.setTitle(panelRactive.get('header'));
        panelRactive.updateLinkVisible = toRestoreContainer.updateLinkVisible.bind(toRestoreContainer);
        if (toRestoreContainer.activeFlagForSave || toRestoreContainer.activeFlagForSave === undefined) {
            panelRactive.setVisibility(true);
        }
        else {
            panelRactive.setVisibility(false);
        }
        toRestoreContainer.elementContent.parentElement.replaceChild(panel, toRestoreContainer.elementContent);
        toRestoreContainer.elementContent = panel;
        toRestoreContainer.dockPlace = dockPlace;
        toRestoreContainer.createHeaderMenuButton();
        toRestoreContainer.createFullscreenModeButton();
        toRestoreContainer.createLinkElements();
        this.tryPermanentlyHideCloseButton(toRestoreContainer, panelRactive);
        if (toRestoreContainer.restoredActiveFlag) {
            this.currentPageDockedWindowsNeedFocusAfterRestore.push(panelRactive);
        }
        if (Object.keys(this.currentPageDockedWindowsForRestore).length === 0) {
            let i = 0;
            const len = this.currentPageDockedWindowsNeedFocusAfterRestore.length;
            for (i = 0; i < len; i++) {
                this.currentPageDockedWindowsNeedFocusAfterRestore[i].setFocus();
            }
            this.currentPageDockedWindowsNeedFocusAfterRestore = [];
        }
    }
    // Ignores newPanelNode.
    findReferenceNodeForDocking(startNode, newPanelNode, dockPlaceInfo) {
        if (startNode === newPanelNode || !dockPlaceInfo) {
            return null;
        }
        const children = startNode.children;
        const len = children ? children.length : 0;
        const containerType = startNode.container.containerType;
        const useFirstMatchedNode = dockPlaceInfo.useFirstMatchedNode;
        const chosenContainerType = dockPlaceInfo.containerType;
        if (chosenContainerType === containerType) {
            if (len) {
                return this.getFirstPanel(children[useFirstMatchedNode ? 0 : len - 1], newPanelNode);
            }
            else {
                return null;
            }
        }
        else {
            for (let i = useFirstMatchedNode ? 0 : len - 1; useFirstMatchedNode ? i < len : i >= 0; useFirstMatchedNode ? i++ : i--) {
                const result = this.findReferenceNodeForDocking(children[i], newPanelNode, dockPlaceInfo);
                if (result) {
                    return result;
                }
            }
        }
        return null;
    }
    // Ignores newPanelNode.
    getFirstPanel(node, newPanelNode) {
        if (!node || node === newPanelNode) {
            return null;
        }
        if (node.container.containerType === 'panel' ||
            (node.container.containerType === 'fill' && !node.children.length)) {
            return node;
        }
        const children = node.children;
        const len = children ? children.length : 0;
        for (let i = 0; i < len; i++) {
            const result = this.getFirstPanel(children[i], newPanelNode);
            if (result) {
                return result;
            }
        }
        return null;
    }
    getDockPlaceInfo(dockPlace) {
        switch (dockPlace) {
            case DockPlaceConst.Middle:
                return null;
            case DockPlaceConst.Up:
                return { containerType: 'vertical', useFirstMatchedNode: true };
            case DockPlaceConst.Down:
                return { containerType: 'vertical', useFirstMatchedNode: false };
            case DockPlaceConst.Left:
                return { containerType: 'horizontal', useFirstMatchedNode: true };
            case DockPlaceConst.Right:
                return { containerType: 'horizontal', useFirstMatchedNode: false };
        }
        return null;
    }
    correctDocumentManagerContainer(curNode) {
        var _a;
        // #88009
        if (this.documentManagerContainerWasFound) {
            return;
        }
        if ((_a = curNode.container) === null || _a === void 0 ? void 0 : _a.isDocumentManagerContainer) {
            this.dockManager.context.model.documentManagerNode = curNode;
            this.documentManagerContainerWasFound = true;
            return;
        }
        const childs = curNode.children;
        for (let i = 0; i < childs.length; i++) {
            this.correctDocumentManagerContainer(childs[i]);
        }
    }
    deletePanelFromDockSystemState(id) {
        if (!this.toRemoveHash) {
            this.toRemoveHash = [];
        }
        this.toRemoveHash.push(id);
    }
    MigationProcess() {
        if (!this.toRemoveHash) {
            return;
        }
        for (let i = 0; i < this.toRemoveHash.length; i++) {
            const id = this.toRemoveHash[i];
            const toRestoreContainer = this.dockManager.restoredHashContainers[id];
            if (!toRestoreContainer) {
                return;
            }
            toRestoreContainer.onCloseButtonClicked();
        }
        this.toRemoveHash.length = 0;
    }
}
DockSystem.divForFloatWindow = null;
DockSystem.hiddenPanelsContainer = null;
export var DockPlaceConst;
(function (DockPlaceConst) {
    DockPlaceConst[DockPlaceConst["Middle"] = 0] = "Middle";
    DockPlaceConst[DockPlaceConst["Up"] = 1] = "Up";
    DockPlaceConst[DockPlaceConst["Down"] = 2] = "Down";
    DockPlaceConst[DockPlaceConst["Left"] = 3] = "Left";
    DockPlaceConst[DockPlaceConst["Right"] = 4] = "Right";
})(DockPlaceConst || (DockPlaceConst = {}));
// DockSystem.divForFloatWindow;
// need forTest Dock system
// function hierarhyTest () {
//     DockSystemInstance.dockManager.layoutEngine.logHierarhy(DockSystemInstance.dockManager.context.model.rootNode, 0);
// }
export const DockSystemInstance = new DockSystem();
// window HACK
window.DockSystem = DockSystemInstance;
